var en_US = require('./en_US');
var zh_CN = require('./zh_CN');
var c = require("../entranceConfig");
window.entrance = c.entrance;
module.exports = {
    languagePack:function(type){
        switch(type){
            case "en_US":
                return en_US;
            default:
                return zh_CN;
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/utiles/locale/config.js
// module id = 205
// module chunks = 0